<!-- 答题 -->
<div class="boxCon2">
  <div class="logo">
    <div class="flex1"><img src="assets/home_tittle_logo.png" alt=""></div>
    <div class="navList">
      <a (click)="goHome()"><img src="assets/home_tittle_ic_sy.png" alt="">首页</a>
      <a (click)="goChangePWD()"><img src="assets/home_tittle_ic_xgmm.png" alt="">修改密码</a>
      <a (click)="goLogin()"><img src="assets/home_tittle_ic_tc.png" alt="">退出</a>
    </div>
  </div>
  <div class="subjectCon">
    <div class="leftList">
      <a class="aSelect2">{{sampleInfo.curStageStr}}</a>
      <div *ngIf="sampleInfo.curStage == '2'">
        <select [(ngModel)]="showType">
          <option *ngFor="let optionOne of showTypeList" [value]="optionOne.code">{{optionOne.name}}</option>
        </select>
      </div>
      <div *ngIf="sampleInfo.curStage == '1' || sampleInfo.curStage == '3'">
        <select [(ngModel)]="showType">
          <option *ngFor="let optionOne of showTypeList2" [value]="optionOne.code">{{optionOne.name}}</option>
        </select>
      </div>
      <div *ngFor="let sample of sampleList">
        <div *ngIf="sampleInfo.curStage == '2'">
          <div *ngIf="showType =='1'">
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}"
              *ngIf="sample.ISRight == '1' && sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span3">正确</span></a>
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}"
              *ngIf="sample.ISRight == '2' && sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span2">错误</span></a>
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}"
              *ngIf="sample.ISRight == '0' && sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span1">完成</span></a>
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}" *ngIf="sample.ISAnswer != '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}</a>
          </div>
          <div *ngIf="showType =='2'">
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}"
              *ngIf="sample.ISRight == '1' && sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span3">正确</span></a>
          </div>
          <div *ngIf="showType =='3'">
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}"
              *ngIf="sample.ISRight == '2' && sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span2">错误</span></a>
          </div>
        </div>
        <div *ngIf="sampleInfo.curStage == '1' || sampleInfo.curStage == '3'">
          <div *ngIf="showType =='1'">
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}" *ngIf="sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span1">完成</span></a>
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}" *ngIf="sample.ISAnswer != '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}</a>
          </div>
          <div *ngIf="showType =='2'">
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}" *ngIf="sample.ISAnswer == '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}<span
                class="span1">完成</span></a>
          </div>
          <div *ngIf="showType =='3'">
            <a [ngClass]="{'aSelect': sample.ORDER_NO == sampleInfo.curOrderNO}" *ngIf="sample.ISAnswer != '1'"
              (click)="changeSample(sample.Sample_NO,sample.ORDER_NO)">样本{{sample.ORDER_NO_SHOW}}</a>
          </div>
        </div>

      </div>
    </div>
    <div class="dtCon">
      <div class="dtSize">共{{sampleInfo.allCount}}题，{{sampleInfo.curStageStr}}已完成{{sampleInfo.answerCount}}题。当前共有{{onLineCount}}人在线。</div>
      <div class="imgCon">
        <div class="imgBig" [ngClass]="{'scrolls': zoomMultiple >100}">
          <img src="{{sampleInfo.curPicSrc}}" alt="" id="curPic_ID" [ngStyle]="styleObj">
        </div>
        <div class="imgSmall">
          <div [ngClass]="{'aSelect': sampleInfo.curPicSrc == sampleInfo.pic1Src}" (click)="changePic('1')">
            <img src="{{sampleInfo.pic1Src}}" alt="">
            <span>{{sampleInfo.pic1Name}}</span>
          </div>
          <div [ngClass]="{'aSelect': sampleInfo.curPicSrc == sampleInfo.pic2Src}" (click)="changePic('2')">
            <img src="{{sampleInfo.pic2Src}}" alt="">
            <span>{{sampleInfo.pic2Name}}</span>
          </div>
          <div [ngClass]="{'aSelect': sampleInfo.curPicSrc == sampleInfo.pic3Src}" (click)="changePic('3')">
            <img src="{{sampleInfo.pic3Src}}" alt="">
            <span>{{sampleInfo.pic3Name}}</span>
          </div>
        </div>
      </div>
      <div class="imgSize">
        <div>{{sampleInfo.curPicName}}</div>
        <div class="fdsxBtn">
          <a (click)="zoomIn()"><img src="assets/nlcs_btn_fd.png" alt="">放大</a>
          <a (click)="zoomOut()"><img src="assets/nlcs_btn_sx.png" alt="">缩小</a>
          <a (click)="restore()"><img src="assets/nlcs_btn_sx.png" alt="">还原</a>
        </div>
      </div>
      <div class="resultCon">
        <div class="resultLeft">
          <div class="titleStyle1">判读结果</div>
          <div class="dxCon borderBottom">
            <div>定性结果：</div>
            <div>
              <input type="radio" name="resultReal" [(ngModel)]="sampleInfo.resultReal" value="001" disabled="{{readonly}}" (change)="changeValue('resultReal')">阳性
              <input type="radio" name="resultReal" [(ngModel)]="sampleInfo.resultReal" value="002" disabled="{{readonly}}" (change)="changeValue('resultReal')">阴性
            </div>
          </div>
          <div class="dxCon">
            <div>核型/滴度：</div>
          </div>
          <div class="dxCon borderBottom">
            <div>
              <span>p-ANCA</span>
              <input type="radio" name="resultReal_P" [(ngModel)]="sampleInfo.resultReal_P" value="001" disabled="{{readonly}}">阳性
              <input type="radio" name="resultReal_P" [(ngModel)]="sampleInfo.resultReal_P" value="002" disabled="{{readonly}}">阴性

              <select [(ngModel)]="sampleInfo.resultReal_P_T" *ngIf="sampleInfo.resultReal_P == '001'" disabled="{{readonly}}">
                <!-- <option [value]="999">---请选择---</option> -->
                <option *ngFor="let titer of titer_P" [value]="titer.code">{{titer.name}}</option>
              </select>
            </div>
          </div>
          <div class="dxCon">
            <div>
              <span>c-ANCA</span>
              <input type="radio" name="resultReal_C" [(ngModel)]="sampleInfo.resultReal_C" value="001" disabled="{{readonly}}">阳性
              <input type="radio" name="resultReal_C" [(ngModel)]="sampleInfo.resultReal_C" value="002" disabled="{{readonly}}">阴性

              <select [(ngModel)]="sampleInfo.resultReal_C_T" *ngIf="sampleInfo.resultReal_C == '001'" disabled="{{readonly}}">
                <!-- <option [value]="999">---请选择---</option> -->
                <option *ngFor="let titer of titer_C" [value]="titer.code">{{titer.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="resultRight" *ngIf="sampleInfo.curStage == '2'">
          <div class="titleStyle2">参考结果</div>
          <div class="dxCon borderBottom">
            <div>定性结果：</div>
            <div>
              <input type="radio" name="resultCompare" [(ngModel)]="sampleInfo.resultCompare" value="001"
                disabled="{{readonly}}">阳性
              <input type="radio" name="resultCompare" [(ngModel)]="sampleInfo.resultCompare" value="002"
                disabled="{{readonly}}">阴性
            </div>
          </div>
          <div class="dxCon">
            <div>核型/滴度：</div>
          </div>
          <div class="dxCon borderBottom">
            <div>
              <span>p-ANCA</span>
              <input type="radio" name="resultCompare_P" [(ngModel)]="sampleInfo.resultCompare_P" value="001"
                disabled="{{readonly}}">阳性
              <input type="radio" name="resultCompare_P" [(ngModel)]="sampleInfo.resultCompare_P" value="002"
                disabled="{{readonly}}">阴性

              <!-- <select [(ngModel)]="sampleInfo.resultCompare_P_T" *ngIf="sampleInfo.resultCompare_P == '001'"
                disabled="{{readonly}}">
                <option *ngFor="let titer of titer_P" [value]="titer.code">{{titer.name}}</option>
              </select> -->
              <span *ngIf="sampleInfo.resultCompare_P == '001'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;滴度：{{sampleInfo.resultCompare_P_T}}</span>
              
              
            </div>
          </div>
          <div class="dxCon borderBottom">
            <div>
              <span>c-ANCA</span>
              <input type="radio" name="resultCompare_C" [(ngModel)]="sampleInfo.resultCompare_C" value="001"
                disabled="{{readonly}}">阳性
              <input type="radio" name="resultCompare_C" [(ngModel)]="sampleInfo.resultCompare_C" value="002"
                disabled="{{readonly}}">阴性

              <!-- <select [(ngModel)]="sampleInfo.resultCompare_C_T" *ngIf="sampleInfo.resultCompare_C == '001'"
                disabled="{{readonly}}">
                <option *ngFor="let titer of titer_C" [value]="titer.code">{{titer.name}}</option>
              </select> -->
              <span *ngIf="sampleInfo.resultCompare_C == '001'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;滴度：{{sampleInfo.resultCompare_C_T}}</span>
            </div>
          </div>
          <div class="dxCon borderBottom">
            <div>
              
              <span>PR3：{{sampleInfo.resultCompare_PR3}}</span>
              <!-- <input type="radio" name="resultCompare_PR3" [(ngModel)]="sampleInfo.resultCompare_PR3" value="001"
                disabled="{{readonly}}">阳性
              <input type="radio" name="resultCompare_PR3" [(ngModel)]="sampleInfo.resultCompare_PR3" value="002"
                disabled="{{readonly}}">阴性
              <select [(ngModel)]="sampleInfo.resultCompare_PR3_T" *ngIf="sampleInfo.resultCompare_PR3 == '001'"
                disabled="{{readonly}}">
                <option *ngFor="let titer of titer_PR3" [value]="titer.code">{{titer.name}}</option>
              </select> -->
            </div>
          </div>
          <div class="dxCon borderBottom">
            <div>
              <span>MPO：{{sampleInfo.resultCompare_MPO}}</span>
              
              <!-- <input type="radio" name="resultCompare_MPO" [(ngModel)]="sampleInfo.resultCompare_MPO" value="001"
                disabled="{{readonly}}">阳性
              <input type="radio" name="resultCompare_MPO" [(ngModel)]="sampleInfo.resultCompare_MPO" value="002"
                disabled="{{readonly}}">阴性
              <select [(ngModel)]="sampleInfo.resultCompare_MPO_T" *ngIf="sampleInfo.resultCompare_MPO == '001'"
                disabled="{{readonly}}">
                <option *ngFor="let titer of titer_MPO" [value]="titer.code">{{titer.name}}</option>
              </select> -->
            </div>
          </div>
          <div class="dxCon">
            <div>诊断</div>
            <textarea cols="30" rows="10" [(ngModel)]="sampleInfo.resultCompare_D" disabled="{{readonly}}"></textarea>
          </div>
          <div class="dxCon">
            <div>备注</div>
            <textarea cols="30" rows="10" [(ngModel)]="sampleInfo.resultCompare_Remark" disabled="{{readonly}}"></textarea>
          </div>
        </div>
      </div>
      <div class="subject">
        <a class="subBtn1" *ngIf="sampleInfo.curOrderNO != '1'" (click)="change('up')">上一题</a>
        <a class="subBtn2" *ngIf="sampleInfo.curOrderNO != sampleInfo.allCount" (click)="change('down')">下一题</a>
        <a class="subBtn2" *ngIf="!readonly && sampleInfo.curStage == '1' && sampleInfo.curOrderNO == sampleInfo.allCount" (click)="change('sub')">提交</a>
        <a class="subBtn2" *ngIf="!readonly && sampleInfo.curStage == '3' && sampleInfo.curOrderNO == sampleInfo.allCount" (click)="change('sub')">提交</a>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="Telephone">
      <img src="assets/login_tel.png" alt="">
    </div>
    <div>
      <p>技术支持：北京风云朗健科技有限公司</p>
      <p><a target="_blank" href="https://beian.miit.gov.cn/">京ICP备14058841号-1</a></p>
    </div>
  </div>
</div>


